import { cn } from "@/lib/utils";

interface LoadingDotsProps {
  className?: string;
  /** Couleur des dots (classe Tailwind text-*). Défaut : currentColor via text-current. */
  colorClassName?: string;
  /** Taille des dots en px. Défaut : 4. */
  size?: number;
}

/**
 * 3 dots loading staggered — remplace Loader2 spin pour cohérence avec
 * la barre indéterminée du PageLoader. Style Linear / Vercel.
 */
export function LoadingDots({ className, colorClassName = "bg-current", size = 4 }: LoadingDotsProps) {
  const style = { width: `${size}px`, height: `${size}px` } as const;
  return (
    <span
      className={cn("inline-flex items-center gap-1", className)}
      role="status"
      aria-label="Chargement"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          aria-hidden="true"
          style={{ ...style, animationDelay: `${i * 160}ms` }}
          className={cn("inline-block rounded-full motion-dots-pulse", colorClassName)}
        />
      ))}
    </span>
  );
}
